// extracted by mini-css-extract-plugin
module.exports = {"builtLonger":"builtLonger_builtLonger__Q5Axc"};